import React, { Component } from 'react'

class CheckboxField extends Component {
    constructor() {
        super()
        this.onClick = this.onClick.bind(this)
    }

    onClick(value) {
        return this.props.input.onChange(this.props.input.value = this.refs.input.checked)
    }

    render() {
        const { label, name, input, initialValues, meta: { error, touched }, className = 'checkbox-inline', selectAll } = this.props
        return (
            <div>
                <div className='col-md-12'>
                    <div className={ `${className} checkbox-inline` }>
                        <label>
                            <input
                                { ...input }
                                type='checkbox'
                                ref='input'
                                name={ name }
                                value={ true }
                                onClick={ this.onClick.bind(this, true) }
                                defaultChecked={ initialValues && initialValues === true }
                            />
                            { label }
                        </label>
                    </div>
                    { touched && ((error && <p className='error'>{error}</p>)) }
                </div>
            </div>
        )
    }
}

export default CheckboxField


// WEBPACK FOOTER //
// ./src/client/features/form/components/CheckboxField.jsx